module.exports = __webpack_public_path__ + "img/output-of-training-model-01.5c9c8db3.png";